const generateRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min)) + min;

export let _produtoLocal;
export let _temImpendimento;
export let _valorTotal;

export function ObterProdutoParaIncluirNoCarrinho(){
  return _produtoLocal;
}

export function IncluirNovoProduto(id, valor, somenteRetirada,nome,observacao_cliente,quantidade, permite_cupom_desconto = 'S')
{
  let produto = {
    id: 0,
    nome: "",
    valor: 0,
    codigo_local: 0,
    quantidade: 1,
    adicionais: [],
    observacao_cliente: "",
    permite_cupom_desconto: permite_cupom_desconto,
  };
  produto.id = id;
  produto.valor = valor;
  produto.somente_retirada = somenteRetirada;
  produto.nome = nome;
  if(quantidade && quantidade > 1)
    produto.quantidade = quantidade;
  produto.observacao_cliente = observacao_cliente;
  produto.codigo_local = generateRandomInt(11111, 99999);
  _produtoLocal = produto;
  _valorTotal = parseFloat(valor);
}

export function IncluirNovoAdicionalNoProduto(adicional){
  adicional.produto_adicional_cat_id = 0;
  adicional.cat_nome = "Adicionais";
  adicional.quantidade = 1;
  _produtoLocal.adicionais.push(adicional);
  IncrementarValorTotal(adicional.valor);
}

export function IncluirNovoAdicionalDaCategoriaNoProduto(categoria, adicional, pizza_maior_preco)
{
  console.log(adicional)
  if (
    categoria.limitar == "S" &&
    categoria.quantidade >= categoria.maximo
  ) {
    M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
    return;
  }

  if (
    adicional.limitar == "S" &&
    adicional.quantidade >= adicional.maximo
  ) {
    M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
    return;
  }

  let fator = adicional.fator_acrescimo ? adicional.fator_acrescimo : 1;
  if (adicional.usa_fator_acrescimo == "S") {
    fator = adicional.fator_acrescimo ? adicional.fator_acrescimo : 1;
  } else {
    fator = 1;
  }

  if (adicional.minimo > 0 && adicional.quantidade < adicional.minimo) {
    if (
      categoria.limitar == "S" &&
      categoria.quantidade + adicional.minimo > categoria.maximo
    ) {
      M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
      return;
    }
  } else {
    if (
      categoria.limitar == "S" &&
      categoria.quantidade + fator > categoria.maximo
    ) {
      M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
      return;
    }
  }
  //

  adicional.cat_nome = categoria.nome;

  if (adicional.minimo > 0 && adicional.quantidade < adicional.minimo) {
    if (fator) {
      if (fator > adicional.minimo) {
        adicional.quantidade = adicional.quantidade + fator;
        categoria.quantidade = categoria.quantidade + fator;
      } else {
        adicional.quantidade = adicional.quantidade + adicional.minimo;
        categoria.quantidade = categoria.quantidade + adicional.minimo;
      }
    } else {
      adicional.quantidade = adicional.quantidade + adicional.minimo;
      categoria.quantidade = categoria.quantidade + adicional.minimo;
    }
  } else {
    adicional.quantidade = adicional.quantidade + fator;
    categoria.quantidade = categoria.quantidade + fator;
  }
  //

  if (
    pizza_maior_preco == "S" &&
    categoria.pizza_tamanho_id
  ) {
    if (parseFloat(adicional.valor) > categoria.maiorValor) {
      categoria.maiorValor = parseFloat(adicional.valor);

      for (let i = 0; i < categoria.adicionais.length; i++) {
        if (
          categoria.maiorValor > parseFloat(categoria.adicionais[i].valor)
        ) {
          if (!categoria.adicionais[i].original)
            categoria.adicionais[i].original =
              categoria.adicionais[i].valor;

          if (categoria.adicionais[i].quantidade > 0)
            DecrementarValorTotal(
              categoria.adicionais[i].valor *
              categoria.adicionais[i].quantidade
            );

          categoria.adicionais[i].valor = categoria.maiorValor.toFixed(2);

          if (categoria.adicionais[i].quantidade > 0)
            IncrementarValorTotal(
              categoria.adicionais[i].valor *
              categoria.adicionais[i].quantidade
            );
        }
      }
    }
  }

  if (!_produtoLocal.adicionais.includes(adicional))
    _produtoLocal.adicionais.push(adicional);

  if (adicional.minimo > 0 && adicional.quantidade <= adicional.minimo) {
    IncrementarValorTotal(adicional.valor, adicional.quantidade);
  } else {
    IncrementarValorTotal(adicional.valor);
  }
}

export function IncrementarValorTotal(valor, qtd = 0) {
  if (valor != "0.00") {
    if (qtd > 0) {
      _valorTotal =
        _valorTotal + parseFloat(valor * qtd);
    } else {
      _valorTotal =
        _valorTotal + parseFloat(valor);
    }
  } else {
    _valorTotal =
      _valorTotal + 0.01;
    _valorTotal =
      _valorTotal - 0.01;
  }
}

export function DecrementarValorTotal(valor, qtd = 0) {
  if (valor != "0.00") {
    if (qtd > 0) {
      _valorTotal =
        _valorTotal - parseFloat(valor * qtd);
    } else {
      _valorTotal =
        _valorTotal - parseFloat(valor);
    }
    //
  } else {
    _valorTotal =
      _valorTotal - 0.01;
    _valorTotal =
      _valorTotal + 0.01;
  }
}



// WEBPACK FOOTER //
// ./src/services/produto.js